export default {
  InitBaseData() {
    return true;
  },
  ProcessBaseEdges() {
    return true;
  },
  ProcessBaseSurface() {
    return true;
  },
  ProcessModules() {
    return true;
  },
  GenThumbail() {
    return true;
  },
  FreeBaseData() {
    return true;
  },
  InitElevation() {
    return true;
  },
  ModelFit() {
    return true;
  },
  UIGetParams() {
    return true;
  },
  CalcElevation() {
    return true;
  },
  FreeElevation() {
    return true;
  },
  getPixelIndexAndValue() {},
  getNumVals() {},
  MallocNetPtr() {
    return {
      result: 1
    };
  },
  readMinMaxVals() {},
  ReadPupilPara() {},
  MallocPWNetPtr() {},
  UIGetPupilandCorneaXYR() {},
  UICalibRingsCoordinates_all360directions() {},
  ExportHeightDatainTriplet() {}
};



// WEBPACK FOOTER //
// ./src/topography/js/CalCaseDebug.js